"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.shuffleArrayBySeed = void 0;
var seedrandom_1 = __importDefault(require("seedrandom"));
var shuffleArrayBySeed = function (array, seed) {
    var rnd = (0, seedrandom_1.default)(seed);
    var randomizedArray = [];
    for (var i = 0; i < array.length; i++) {
        randomizedArray.splice(Math.floor(rnd() * i), 0, array[i]);
    }
    return randomizedArray;
};
exports.shuffleArrayBySeed = shuffleArrayBySeed;
//# sourceMappingURL=shuffleArrayBySeed.js.map